import { render, staticRenderFns } from "./DisplayVersion.vue?vue&type=template&id=22267200&scoped=true&"
import script from "./DisplayVersion.vue?vue&type=script&lang=ts&"
export * from "./DisplayVersion.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayVersion.vue?vue&type=style&index=0&id=22267200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22267200",
  null
  
)

export default component.exports